import { useEffect, useState } from "react";
import { MenuItems } from "../types";
import { getRange } from "../helpers/getRange";
import { TMenuIds } from "../../../app/state/menuSlice/types";
import { TEntityInfo } from "../../types/utility";
import { findItemById } from "../../../app/state/storageObjectSlice/utils/findItemById";

export const useRangeSelection = (
  items: MenuItems,
  onSelect: (id: string) => void,
  handleOpenMenu: (
    e: React.MouseEvent | HTMLElement,
    id: TMenuIds,
    entity: TEntityInfo | null,
    subtype: string,
  ) => void,
  selectedId: string,
) => {
  const [anchorId, setAnchorId] = useState<string | null>(null);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  useEffect(() => {
    setAnchorId(selectedId);
  }, [selectedId]);

  const handleClick = (
    event: React.MouseEvent,
    id: string,
    element: HTMLElement,
  ) => {
    if (event.shiftKey) {
      event.preventDefault();

      if (!anchorId) {
        setAnchorId(id);
        return;
      }
      const current = findItemById(items, selectedId);
      const range = getRange(items, anchorId, id);
      setSelectedIds(range);
      if (current && current.value !== null) {
        handleOpenMenu(element, "sidebar_item_transfer_menu", null, "sidebar");
      }
      return;
    }

    reset();
  };

  const handleItemClick = (e: React.MouseEvent, id: string) => {
    if (e.shiftKey) {
      const element = e.currentTarget as HTMLElement;
      handleClick(e, id, element);
      return;
    }
    reset();
    setAnchorId(id);
    onSelect(id);
  };

  const reset = () => {
    setSelectedIds([]);
  };

  return { selectedIds, handleItemClick, reset };
};
